import React from 'react';

var NoticeTemplate = function NoticeTemplate(props) {
  return /*#__PURE__*/React.createElement("span", null, props.data.attachment && props.data.attachment[0] && props.data.attachment[0].external_url ? /*#__PURE__*/React.createElement("a", {
    href: props.data.attachment[0].external_url,
    title: props.data.attachment[0].title,
    target: "_blank",
    rel: "noreferrer noopener"
  }, /*#__PURE__*/React.createElement("strong", null, props.data.title.replace(/&nbsp;/g, '').replace(/&pound;/g, '£'), props.data.snippet.replace(/&nbsp;/g, '').replace(/&pound;/g, '£') && ': '), props.data.snippet.replace(/&nbsp;/g, '').replace(/&pound;/g, '£')) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("strong", null, props.data.title.replace(/&nbsp;/g, '').replace(/&pound;/g, '£'), props.data.snippet.replace(/&nbsp;/g, '').replace(/&pound;/g, '£') && ': '), props.data.snippet.replace(/&nbsp;/g, '').replace(/&pound;/g, '£')));
};

export default NoticeTemplate;